const coursesData = [
  {
    id: 1,
    title: "Full-Stack Web Development",
    instructor: "Arjun Mehta",

    // 🔹 Listing Page (One Line Only)
    shortDescription:
      "Master modern web development with React, Node.js & more.",

    // 🔹 Details Page (Full Content)
    fullDescription:
      "Become a job-ready full-stack developer by mastering HTML, CSS, JavaScript, React, Node.js, Express, and MongoDB. Build real-world projects, implement authentication, design REST APIs, and deploy applications with best practices used in the industry.",

    rating: 4.8,
    price: 4999,

    image:
      "https://images.unsplash.com/photo-1587620962725-abab7fe55159?q=80&w=1200",

    includes: [
      "25+ HD Video Lessons",
      "Real-world Projects",
      "Source Code Access",
      "Lifetime Access",
      "Certificate of Completion",
    ],
  },

  {
    id: 2,
    title: "UI/UX Design Masterclass",
    instructor: "Priya Patel",

    shortDescription:
      "Design stunning interfaces with Figma and modern principles.",

    fullDescription:
      "From wireframes to polished prototypes, learn the complete UI/UX design workflow. Master Figma, design systems, user research, accessibility, usability testing, and create portfolio-worthy projects that land you your dream design role.",

    rating: 4.7,
    price: 3499,

    image:
      "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?q=80&w=1200",

    includes: [
      "20+ HD Video Lessons",
      "Lifetime Access",
      "Downloadable Resources",
      "Certificate of Completion",
    ],
  },

  {
    id: 3,
    title: "Data Science & Analytics",
    instructor: "Rahul Sharma",

    shortDescription:
      "Turn raw data into actionable insights with Python & SQL.",

    fullDescription:
      "Learn Python, Pandas, NumPy, SQL, and data visualization to analyze real-world datasets. Build dashboards, perform statistical analysis, and understand machine learning basics to transform data into meaningful business insights.",

    rating: 4.9,
    price: 5499,

    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200",

    includes: [
      "30+ HD Video Lessons",
      "Hands-on Data Projects",
      "Downloadable Datasets",
      "Lifetime Access",
      "Certificate of Completion",
    ],
  },
];

export default coursesData;